/* @flow */
import React, { Component } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/input.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/menu.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/checkbox.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/dropdown.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import debounce from 'debounce-promise'
import './styles.scss'
import config from 'config'
import { Radio } from 'semantic-ui-react'
import Dropdown from 'react-dropdown'
import 'react-dropdown/style.css'
import { LocaleContext } from '../../contexts/locale'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { SortToggle } from 'components/toggle'

import de from './locales/de.yml'
import fr from './locales/fr.yml'

const MESSAGES = { de, fr }

type Team = {
  AssociationName: string,
  ClubNumber: string,
  ID: string,
  LeagueGender: string,
  LeagueGroupNumber: string,
  LeagueNameDE: string,
  LeagueRank: string,
  Name: string
}

type Club = {
  ID: number,
  NAME: string,
  ASSOCIATION: string
}

type Association = {
  ID: number,
  NAME: string
}

type Gender = {
  value: String,
  label: String
}

const associations: Array<Association> = require('../../data/associations.csv')
// const leagues = {
//   M: require('../../data/leagues_M.csv'),
//   F: require('../../data/leagues_F.csv')
// }

type Props = {
  onSelectionHandler: () => {}
}

type State = {
  isLoading: boolean,
  results: Array<Club>,
  textFilteredResults: Array<Club>,
  selectedGender: String,
  selectedAffiliation: string,
  selectedLeague: Number,
  selectedAssociation: Array<Association>,
  value: string,
  groups: Array<Number>,
  genders: Array<String>,
  leaguesDd: Array<Number>,
  regions: Array<String>,
  teams: Array<Team>,
  error: null | 'error.noResultsByZip' | 'error.noResultsByName'
}

export class SearchField extends Component<Props, State> {
  static contextType = LocaleContext

  resetComponent = () => {
    const teams = require('../../data/all_teams.csv')
    let defaultAssociation = associations.find(
      a => a.PublicationName.split(', ').includes(parseHostname().publicationName)
    )

    if (defaultAssociation) {
      defaultAssociation = defaultAssociation.Name
    } else {
      defaultAssociation = 'FVBJ'
    }

    this.setState(
      {
        isLoading: false,
        selectedGender: 'M',
        selectedAssociation: defaultAssociation,
        selectedLeague: null,
        selectedGroup: null,
        results: [],
        textFilteredResults: [],
        value: '',
        groups: [],
        genders: [],
        leaguesDd: [],
        associations: associations.filter(a => a.LeagueGender === 'M'),
        teams: teams
      },
      () => {
        this.filter()
      }
    )
  }

  filterList = (
    searchTerm: string,
    gender: String,
    region: String,
    league: number,
    group: number
  ) => {
    let teams
    console.group()

    // 1. Get the teams and available genders for the selected region
    try {
      teams = require('../../data/' + region + '_teams.csv')
    } catch (e) {
      if (e.code !== 'MODULE_NOT_FOUND') {
        throw e
      }
      teams = []
    }
    this.setState({
      genders: [
        ...new Set(teams.reduce((a, b) => [...a, b.LeagueGender], []))
      ].sort()
    })

    console.log('All the teams for ' + region)
    console.log(teams)

    // 2. Filter by gender
    teams = teams.filter(t => t.LeagueGender === gender)

    console.log(`Filtered by gender ${gender}`)
    console.log(teams)

    // Set the leagues for this region and gender
    const _leagues = []

    teams.forEach(t => {
      !_leagues.reduce((a, b) => [...a, b.value], []).includes(+t.LeagueRank) &&
        _leagues.push({
          value: +t.LeagueRank,
          label: t.LeagueNameDE
        })
    })

    _leagues.sort((a, b) => a.value - b.value)

    this.setState({
      selectedLeague: !league ? _leagues[0].value : this.state.selectedLeague,
      leaguesDd: _leagues
    })

    // 3. Filter by league
    teams = teams.filter(
      t => +t.LeagueRank === (league ? +league : _leagues[0].value)
    )

    console.log(
      `${
        league
          ? 'Filtered by league ' + league
          : 'No league specified, choose ' + _leagues[0].value + ' by default'
      }`
    )
    console.log(teams)

    // Set the remaining groups according to the filtered teams
    this.setState({
      groups: [
        ...new Set(teams.reduce((a, b) => [...a, b.LeagueGroupNumber], []))
      ].sort()
    })

    // 3. Filter the result by group
    const results =
      group !== null
        ? teams.filter(item => +item.LeagueGroupNumber === +group)
        : teams

    console.log('Finally, filtered by group ' + group)
    console.log(results)
    console.groupEnd()

    return Promise.resolve(results)
  }

  debounceFilter = debounce(this.filterList, 300, { leading: true })

  handleSearchChange = e => {
    const value = e.currentTarget.value
    this.setState({ value })

    // Filter the result by text
    // Only start filtering once we have enough data
    const searchTerm = value.trim()

    if (searchTerm.length > 2) {
      const sanitizedSearchTerm = searchTerm
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      const r = RegExp(sanitizedSearchTerm, 'i')

      const textFilteredResults = this.state.teams.filter(team =>
        r.test(team.Name.normalize('NFD').replace(/[\u0300-\u036f]/g, ''))
      )

      if (textFilteredResults.length < 1) {
        this.setState({
          textFilteredResults: [],
          error: 'error.noResultsByName'
        })
      } else {
        this.setState({ textFilteredResults, error: null })
      }

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'Interactions',
        event_action: 'input',
        event_label: `search:for_${searchTerm}:results_${textFilteredResults.length}`
      })
    } else {
      this.setState({ textFilteredResults: this.state.results, error: null })
    }
  }

  // Gender filter
  handleGenderSelection(gender: 'M' | 'F') {
    const associationsList = associations.filter(a => a.LeagueGender === gender)

    console.group()
    console.log('Available associations for this gender:')
    console.log(associationsList)

    console.log('Selected association:')
    console.log(this.state.selectedAssociation)

    let a = associations.find(a => a.Name === this.state.selectedAssociation)
      .Name
    if (!a) {
      console.log("This association hasn't any team for this gender...")
      a = associationsList[0].Name
      console.log('... so the selected association is now ' + a)
    }

    this.setState(
      {
        selectedGender: gender,
        selectedLeague: null,
        selectedGroup: null,
        associations: associationsList,
        selectedAssociation: a
      },
      this.filter
    )

    console.groupEnd()
  }

  // Region filter
  handleRegionFilterSelection(associationName: string) {
    this.setState(
      {
        selectedAssociation: associationName,
        selectedLeague: null,
        selectedGroup: null
      },
      this.filter
    )
  }

  // League filter
  handleLeagueSelection(league: Number) {
    this.setState(
      {
        selectedLeague: league,
        selectedGroup: null
      },
      this.filter
    )
  }

  // Group filter
  handleGroupSelection(group: Number) {
    this.setState(
      {
        selectedGroup: group
      },
      this.filter
    )
  }

  // getLeague(gender, number) {
  //   console.log('GET League ' + number + ' - ' + gender)
  //   console.log(leagues)
  //   const selectedLeague = leagues[gender].filter(l => +l.value === +number)[0]
  //   if (selectedLeague) {
  //     return leagues[gender].filter(l => +l.value === +number)[0]
  //   } else {
  //     this.setState({
  //       selectedLeague: leagues[gender][0].value
  //     })
  //     return leagues[gender][0]
  //   }
  // }

  groups(g) {
    const groups = [
      {
        label: 'Alle',
        value: null
      }
    ]
    g.forEach(g => {
      groups.push({
        label: 'Gruppe ' + g,
        value: g
      })
    })

    return groups
  }

  filter() {
    console.log()
    console.log('>> FILTER')
    console.log(
      this.state.value,
      this.state.selectedGender,
      this.state.selectedAssociation,
      this.state.selectedLeague,
      this.state.selectedGroup
    )
    this.filterList(
      this.state.value,
      this.state.selectedGender,
      this.state.selectedAssociation,
      this.state.selectedLeague,
      this.state.selectedGroup
    ).then(results => {
      if (results.length > 0) {
        this.setState({ error: null })
      } else {
        this.setState({ error: 'error.noResultsByLeague' })
      }
      this.setState({
        value: '',
        results,
        textFilteredResults: results,
        isLoading: false
      })
    })
  }

  // region React Component Lifecycle
  componentWillMount() {
    this.resetComponent()
  }

  render() {
    const t = config.translationServiceFactory(MESSAGES, this.context)
    const { isLoading, results, groups } = this.state
    const groupsDropDown = this.groups(groups)
    const associationsList = this.state.associations
      .reduce((a, b) => [...a, { label: b.FullName, value: b.Name }], [])
      .sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0))
    return (
      <div className='municipality-search'>
        {true && (<div className='ui text container'>
          <div className='ui icon message'>
            <div className='content'>
              <div className='header'><i className='icon file alternate'></i>Angebot wird pausiert</div>
              <p>Liebe Leserinnen und Leser. 
                Die Daten, die den automatisch geschriebenen Texten zu Grunde liegen, werden von der Website des Schweizerischen Fussballverbandes heruntergeladen. 
                Leider sind dabei in den letzten Monaten immer grössere Hürden aufgetreten, die es uns aktuell verunmöglichen, den Service weiterhin anzubieten. 
                Besten Dank für Ihre Treue!</p>
            </div>
          </div>
          </div>)}
          {/* 
        <h3 className='ui header'>Finden Sie ein Team</h3>

        <div className='two-cols ui bottom segment'>
          <div className='ui stackable doubling four column grid'>
            <div className='column'>
              <SortToggle
                labels={['Männer', 'Frauen']}
                sort={this.state.selectedGender === 'F' ? 1 : 0}
                setSort={e => {
                  this.handleGenderSelection(e ? 'F' : 'M')
                }}
              />
            </div>
            <div className='column'>
              <Dropdown
                options={associationsList}
                value={
                  associations.find(
                    a => a.Name === this.state.selectedAssociation
                  ).FullName
                }
                onChange={e => {
                  this.handleRegionFilterSelection(e.value)
                }}
              />
            </div>

            {this.state.selectedAssociation !== 'LA' &&
              this.state.leaguesDd.length > 0 && (
                <div className='column'>
                  <Dropdown
                    options={this.state.leaguesDd}
                    value={
                      this.state.selectedLeague
                        ? this.state.leaguesDd.find(
                            l => l.value === this.state.selectedLeague
                          ).label
                        : this.state.leaguesDd[0].label
                    }
                    onChange={e => {
                      this.handleLeagueSelection(e.value)
                    }}
                  />
                </div>
              )}

            <div className='column'>
              <Dropdown
                options={groupsDropDown}
                value={
                  this.state.selectedGroup
                    ? groupsDropDown.filter(
                        g => g.value === this.state.selectedGroup
                      )[0].label
                    : 'Alle'
                }
                onChange={e => {
                  this.handleGroupSelection(e.value)
                }}
              />
            </div>
          </div>
        </div>
        <div className='ui bottom segment'>
          <div
            className={`ui fluid ${
              isLoading ? 'loading' : ''
            } large search item`}
          >
            <div className='ui transparent icon input'>
              <input
                type='search'
                className='prompt'
                placeholder='SV Meiringen'
                value={this.state.value}
                onChange={this.handleSearchChange}
              />
              <i className='search link icon' />
            </div>
          </div>
        </div>

        <div
          className={`results ui bottom attached segment ${
            isLoading ? 'loading' : ''
          }`}
        >
          {this.state.error && (
            <label
              htmlFor='search'
              className='ui large green top pointing label'
            >
              {t(this.state.error)}
            </label>
          )}
          <>
            {this.state.textFilteredResults.map((result, index) => (
              <div
                onClick={() => {
                  this.props.onSelectionHandler(result.ID)
                  // this.sendToDataPipeline(result.PLZ4)
                }}
                onKeyUp={e => {
                  if (e.key === 'Enter' || e.key === 'Space') {
                    this.props.onSelectionHandler(result.ID)
                    // this.sendToDataPipeline(result.PLZ4)
                  }
                }}
                className='item'
                key={index}
                tabIndex={0}
              >
                <div className='header'>{result.Name}</div>
                <div className='meta'>
                  {MESSAGES.de.gender[result.LeagueGender]} -{' '}
                  {result.LeagueNameDE}
                </div>
              </div>
            ))}
          </>
        </div> */}
      </div>
    )
  }

  // endregion
}

export default SearchField
